import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';
import {STATUS_OPTIONS} from '@constants/staticDropdowns';

export const StatusFilter = ({
    loading,
    filters,
    restoreFilterValues,
    //Placeholder is needed because we use this common filter 3 times in ClientPackageFilters
    placeholder = 'Status',
    //Status type is needed because of different filters isDisabled=0 || status=1
    statusType = 'IS_ENABLED',
    //Field name is needed because we use this common filter 3 times in ClientPackageFilters
    fieldName,
    //defaultValue & errorMessage are needed in LcrChannelFilters
    defaultValue = null,
    errorMessage = null,
}) => {
    const handleRestoreValues = (filters, currentFieldName) => {
        if (null !== defaultValue && null !== errorMessage) {
            return restoreFilterValues(filters, currentFieldName, defaultValue, errorMessage);
        }

        return restoreFilterValues(filters, currentFieldName);
    };

    return (
        <Field
            component={Form.ReduxSelect}
            disabled={loading}
            loading={loading}
            name={fieldName || 'status'}
            placeholder={placeholder}
            options={STATUS_OPTIONS[statusType]}
            setValue={handleRestoreValues(filters, fieldName || 'status')}
            selection
        />
    );
};

StatusFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    statusType: PropTypes.string,
    fieldName: PropTypes.string,
    defaultValue: PropTypes.number,
    errorMessage: PropTypes.string,
};
